import * as Product from 'types/Ingredient/Detail/Product';

export type Type = Product.Type[];

export function create(): Type {
	return [];
}
